<template>
  <b-card>
    <b-card-header>
      <h4 class="title">لیست واحد های سازمانی</h4>
    </b-card-header>
    <b-card-body>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="success"
        class="mb-1 float-right"
        target="_blank"
        :href="exportExcel"
      >
        <feather-icon icon="FileTextIcon" class="mr-50" />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-toggle.filter-box
        variant="outline-primary"
        class="mb-1"
      >
        <feather-icon icon="FilterIcon" class="mr-50" />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse id="filter-box" class="mb-2">
        <b-card class="border mb-0">
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label>نام:</label>
                <b-form-input
                  v-model="search.name"
                  placeholder="نام را وارد نمایید."
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <hr />
          <div class="demo-inline-spacing">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              @click="advanceSearch"
            >
              اعمال جستجو
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              @click="clearSearch"
            >
              حذف فیلترها
            </b-button>
          </div>
        </b-card>
      </b-collapse>

      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table :fields="fields" :items="items" hover striped>
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle" />
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(isActive)="data">
              <b-avatar
                :id="`organization-row-${data.item.id}`"
                size="32"
                :variant="data.value ? 'light-success' : 'light-danger'"
              >
                <feather-icon :icon="data.value ? 'CheckIcon' : 'XIcon'" />
              </b-avatar>
            </template>
            <template #cell(action)="data">
              <b-dropdown text="عملیات" variant="outline-primary">
                <b-dropdown-item
                  :to="{
                    name: 'Organization_Unit_Update',
                    params: { id: data.item.id },
                  }"
                >
                  <feather-icon icon="EditIcon" class="text-warning" />
                  ویرایش
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination,
  BFormInput,
  BCollapse,
  BFormGroup,
  BButton,
  VBToggle,
  BAvatar,
} from "bootstrap-vue";
import VSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { doubleRaf, queryString } from "@/libs/utils";
import { computed } from "@vue/composition-api";
import { debounce } from "@/libs/debounce";

export default {
  name: "Organization_List",
  components: {
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "name",
          label: "نام و نام خانوادگی",
        },
        {
          key: "creator.name",
          label: "سازنده",
        },
        {
          key: "isActive",
          label: "وضعیت",
        },
        {
          key: "parent.name",
          label: "سازمان مادر",
        },
        {
          key: "action",
          label: "عملیات",
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      search: {},
      onExportProgress: false,
    };
  },

  mounted() {
    this.getUsersList();
    this.setSearchData();
  },

  computed: {
    exportExcel() {
      const query = queryString(this.search);
      return `${process.env.VUE_APP_API}organizations?export-excel=1&${query}`;
    },
  },
  methods: {
    getUsersList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query));
      this.onProgress = true;

      this.$http
        .get("organizations", {
          params: {
            ...currentQuery,
            ...this.search,
            page: this.currentPage,
          },
        })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.organizations;
            this.currentPage = data.meta.current_page;
            this.totalRows = data.meta.total;
            this.perPage = data.meta.per_page;
          } else {
            this.$bvToast.toast(
              "در دریافت لیست واحدهای سازمانی خطایی رخ داده",
              {
                title: "حطا",
                toaster: "b-toaster-top-right",
                variant: "danger",
              },
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        })
        .finally(() => {
          this.onProgress = false;
        });
    },
    advanceSearch() {
      this.$router
        .replace({
          name: this.$route.name,
          query: {
            ...this.search,
          },
        })
        .then(() => {
          this.getUsersList();
        })
        .catch(() => {});

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: "smooth" });
      });
    },
    clearSearch() {
      this.$router
        .replace({
          name: this.$route.name,
          query: {},
        })
        .then(() => {
          this.getUsersList();
        })
        .catch(() => {});

      this.search = {};
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: "smooth" });
      });
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUser(loading, search, this);
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search);
      loading(false);
    }, 400),
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query));
      });
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: "Organization_Unit_Update",
          query: { page: this.currentPage },
        });
        this.items = [];
        this.getUsersList();
      }
    },
  },
};
</script>

<style></style>
